import { z } from "zod";

export const preferredCleanerSetIdSchema = z.string().regex(/^[0-9a-f]{32}$/u);
const preferredCleanerSetUserIdSchema = z.string().regex(/^[0-9a-f]{32}$/u);

export const preferredCleanerSetCleanerSchema = z.strictObject({
  cleanerUserId: preferredCleanerSetUserIdSchema,
  rankNo: z.number().int().min(1).max(20),
  publicName: z.string().nullable(),
});

export const preferredCleanerSetSchema = z.strictObject({
  setId: preferredCleanerSetIdSchema,
  name: z.string().min(1),
  cleaners: z.array(preferredCleanerSetCleanerSchema),
});

export const preferredCleanerSetListResponseSchema = z.strictObject({
  status: z.literal("ok"),
  sets: z.array(preferredCleanerSetSchema),
});

export const createPreferredCleanerSetInputSchema = z.strictObject({
  name: z.string().trim().min(1).max(100),
  cleanerUserIds: z.array(preferredCleanerSetUserIdSchema).min(1).max(20),
});

export const createPreferredCleanerSetResponseSchema = z.strictObject({
  status: z.literal("created"),
  set: preferredCleanerSetSchema,
});

export const deletePreferredCleanerSetResponseSchema = z.strictObject({
  status: z.literal("deleted"),
});

export type PreferredCleanerSet = z.infer<typeof preferredCleanerSetSchema>;
export type CreatePreferredCleanerSetInput = z.infer<typeof createPreferredCleanerSetInputSchema>;
